'use client'

import { CompanyCard } from '../../../components/landing/ticker-store/company-card'

interface Company {
    id: string
    logo: string
    title: string
    body: string
    description: string
}

interface TickerStoreGridProps {
    companies: Company[]
}

export function TickerStoreGrid({ companies }: TickerStoreGridProps) {
    const handleCompanyClick = (company: Company) => {
        console.log('Company clicked:', company)
        // TODO: Navigate to company details page
    }

    return (
        <div className="space-y-5">
            {/* Header with Explore text and Search input */}
            <div className="flex items-center justify-between gap-4">
                <h2 className="text-[26px] leading-[32px] font-bold text-black/80 dark:text-white/80">
                    Explore
                </h2>
                <input
                    type="text"
                    placeholder="Search companies..."
                    className="border border-black/[0.06] dark:border-white/[0.06] py-[10px] pl-[10px] pr-[15px] rounded-[50px] bg-transparent text-sm focus:outline-none focus:ring-2 focus:ring-black/10 dark:focus:ring-white/10 transition-shadow"
                />
            </div>

            {/* Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {companies.map((company) => (
                    <CompanyCard
                        key={company.id}
                        logo={company.logo}
                        title={company.title}
                        body={company.body}
                        description={company.description}
                        onClick={() => handleCompanyClick(company)}
                    />
                ))}
            </div>
        </div>
    )
}
